import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSlider from "../../components/sliders/FormAddEditSlider";

const CreateSlider = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/sliders");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSlider
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateSlider;